import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const bluesky = defineConnector({
  identifier: "bluesky",
  name: "Bluesky",
  tagLine: "Decentralized social network",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () =>
    "https://(?:bsky\\.social/xrpc/.*|[^/]*\\.bsky\\.network/xrpc/.*)",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://bsky.social/xrpc/com.atproto.server.createSession",
        method: "POST",
        jsonBody: {
          identifier: app.config.handle,
          password: app.secret.appPassword,
        },
      },
      extract: { from: "jsonPath", paths: ["accessJwt"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create an app password",
      items: [
        {
          kind: "markdown",
          content:
            "In Bluesky, go to **Settings → App passwords** and create a new app password.",
        },
        {
          kind: "input",
          label: "Handle",
          required: true,
          placeholder: "you.bsky.social",
          target: { kind: "configuration", field: "handle" },
        },
        {
          kind: "input",
          label: "App password",
          required: true,
          target: { kind: "secrets", field: "appPassword" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ handle }) =>
      `https://bsky.social/xrpc/app.bsky.actor.getProfile?actor=${handle}`,
  },
});
